import { render } from "./RestoreAhModal.vue?vue&type=template&id=c4078808&scoped=true"
import script from "./RestoreAhModal.vue?vue&type=script&lang=js"
export * from "./RestoreAhModal.vue?vue&type=script&lang=js"

import "./RestoreAhModal.vue?vue&type=style&index=0&id=c4078808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4078808"]])

export default __exports__